export default "__VITE_ASSET__DnqWyyYg__"